import * as React from "react";
import { cn } from "@shortsworks/ui/lib/utils";

const MainTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn("leading-none tracking-tight text-xl font-bold", className)}
    {...props}
  />
));
MainTitle.displayName = "MainTitle";

export { MainTitle };
